import { z } from 'zod'

export enum FeatureFlag {
  Rules = 'rules',
  Registry = 'registry',
  Schemas = 'schemas',
  SDK = 'sdk',
  CLI = 'cli',
  Agent = 'agent',
  MCP = 'mcp',
  Workspaces = 'workspaces',
  Export = 'export',
}

const featureSchema = z.boolean().optional().meta({ id: 'feature' })

export const featureFlagSchema = z
  .object({
    [FeatureFlag.Rules]: featureSchema,
    [FeatureFlag.Registry]: featureSchema,
    [FeatureFlag.Schemas]: featureSchema,
    [FeatureFlag.SDK]: featureSchema,
    [FeatureFlag.CLI]: featureSchema,
    [FeatureFlag.Agent]: featureSchema,
    [FeatureFlag.Workspaces]: featureSchema,
    [FeatureFlag.MCP]: featureSchema,
    [FeatureFlag.Export]: featureSchema,
  })
  .meta({ id: 'feature-flag' })
